import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { ToastrModule } from 'ngx-toastr';

import { S1Module  } from '../s1/s1.module';

import { AccordionModule } from 'ngx-bootstrap/accordion';
import { AlertModule } from 'ngx-bootstrap/alert';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { RatingModule } from 'ngx-bootstrap/rating';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TimepickerConfig, TimepickerModule } from 'ngx-bootstrap/timepicker';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

import { FlotDirective } from './directives/flot/flot.directive';
import { SparklineDirective } from './directives/sparkline/sparkline.directive';
import { EasypiechartDirective } from './directives/easypiechart/easypiechart.directive';
import { ColorsService } from './colors/colors.service';
import { CheckallDirective } from './directives/checkall/checkall.directive';
import { VectormapDirective } from './directives/vectormap/vectormap.directive';
import { NowDirective } from './directives/now/now.directive';
import { ScrollableDirective } from './directives/scrollable/scrollable.directive';
import { JqcloudDirective } from './directives/jqcloud/jqcloud.directive';

import { 
    RuoliUtenteSelectComponent,
    InfoUtenteComponent,
    InputNumberComponent
} from './index';

import { PreferitiComponent } from './components/preferiti/preferiti.component';
import { AzioniPreferitiModal } from './components/azioni-preferiti-modal/azioni-preferiti-modal.component';
import { AzioniMenuRicercaComponent } from './components/azioni-menu-ricerca/azioni-menu-ricerca.component';
import { AzioneMenuModalComponent } from './components/azione-menu-modal/azione-menu-modal.component';
import { FunzioniAzioneMenuSectionComponent } from './components/funzioni-azione-menu-section/funzioni-azione-menu-section.component';
import { FunzioneAzioneMenuModalComponent } from './components/funzione-azione-menu-modal/funzione-azione-menu-modal.component';
import { TipoAllegatoSelectComponent } from './components/tipo-allegato-select/tipo-allegato-select.component';
import { AllegatoModalComponent } from './components/allegato-modal/allegato-modal.component';
import { AllegatiSectionComponent } from './components/allegati-section/allegati-section.component';
import { AllegatiTipoSectionComponent } from './components/allegati-tipo-section/allegati-tipo-section.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { ScrollToBottomDirective } from './directives/scoll/scroll-to-bottom.directive';

import { CassaSelectComponent } from './components/cassa-select/cassa-select.component';
import { StazioneComponent } from './components/stazione/stazione.component';
import { StazioniComponent } from './components/stazioni/stazioni.component';
import { AzureLoginComponent } from './components/azure-login/azure-login.component';
import { AssociaStazioneModalComponent } from './components/associa-stazione-modal/associa-stazione-modal.component';
import { CasseComponent } from './components/casse/casse.component';
import { CassaComponent } from './components/cassa/cassa.component';
import { TipoCassaSelectComponent } from './components/tipo-cassa-select/tipo-cassa-select.component';
import { TipoPistaSelectComponent } from './components/tipo-pista-select/tipo-pista-select.component';
import { PisteComponent } from './components/piste/piste.component';
import { PistaComponent } from './components/pista/pista.component';
import { TipoAssistenzaSelectComponent } from './components/tipo-assistenza-select/tipo-assistenza-select.component';
import { StazioneSelectComponent } from './components/stazione-select/stazione-select.component';
import { TipoPagamentoSelectComponent } from './components/tipo-pagamento-select/tipo-pagamento-select.component';
import { PistaSelectComponent } from './components/pista-select/pista-select.component';
import { ClasseVeicoloSelectComponent } from './components/classe-veicolo-select/classe-veicolo-select.component';
import { ModalitaAssistenzaCasseSelectComponent } from './components/modalita-assistenza-casse-select/modalita-assistenza-casse-select.component';
import { InGestioneSelectComponent } from './components/in-gestione-select/in-gestione-select.component';
import { StazioneEntrataSelectComponent } from './components/stazione-entrata-select/stazione-entrata-select.component';
import { TrattaSelectComponent } from './components/tratta-select/tratta-select.component';
import { WidgetCassaComponent } from './components/widget-cassa/widget-cassa.component';
import { TipoAssistenzaBadgeComponent } from './components/tipo-assistenza-badge/tipo-assistenza-badge.component';
import { StatoAssistenzaBadgeComponent } from './components/stato-assistenza-badge/stato-assistenza-badge.component';
import { StatoAssistenzaSelectComponent } from './components/stato-assistenza-select/stato-assistenza-select.component';
import { TipoCodiceSelectComponent } from './components/tipo-codice-select/tipo-codice-select.component';
import { TipoAssistenzaReportComponent } from './components/tipo-assistenza-report/tipo-assistenza-report.component';
import { TotaliStazioneBadgeComponent } from './components/totali-stazione-badge/totali-stazione-badge.component';
import { BottoniStatoAssistenzaComponent } from './components/bottoni-stato-assistenza/bottoni-stato-assistenza.component';
import { TipoScontrinoSelectComponent } from './components/tipo-scontrino-select/tipo-scontrino-select.component';
import { NewTabButtonComponent } from './components/new-tab-button/new-tab-button.component';
import { OperatoreSelectComponent } from './components/operatore-select/operatore-select.component';
import { BottoniStampaAssistenzaComponent } from './components/bottoni-stampa-assistenza/bottoni-stampa-assistenza.component';
import { ConBarcodeSelectComponent } from './components/con-barcode-select/con-barcode-select.component';
import { ConRimborsoAmministrativoSelectComponent } from './components/con-rimborso-amministrativo-select/con-rimborso-amministrativo-select.component';

// Temporary workaround to show time picker in 24H format instead of am/pm
// https://github.com/valor-software/ngx-bootstrap/issues/6373#issuecomment-2182981636 
export function getTimepickerConfig(): TimepickerConfig {
    return Object.assign(new TimepickerConfig(), {
    showMeridian: false,
    });
}

// https://angular.io/styleguide#!#04-10
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        AccordionModule.forRoot(),
        AlertModule.forRoot(),
        ButtonsModule.forRoot(),
        CarouselModule.forRoot(),
        CollapseModule.forRoot(),
        BsDatepickerModule.forRoot(),
        BsDropdownModule.forRoot(),
        ModalModule.forRoot(),
        PaginationModule.forRoot(),
        ProgressbarModule.forRoot(),
        RatingModule.forRoot(),
        TabsModule.forRoot(),
        TimepickerModule.forRoot(),
        TooltipModule.forRoot(),
        PopoverModule.forRoot(),
        TypeaheadModule.forRoot(),
        ToastrModule.forRoot(),
        TooltipModule.forRoot(),
        S1Module.forRoot(),
        NgxExtendedPdfViewerModule,
        RouterModule
    ],
    providers: [
        ColorsService,
        TranslatePipe,
        { provide: TimepickerConfig, useFactory: getTimepickerConfig }
    ],
    declarations: [
        FlotDirective,
        SparklineDirective,
        EasypiechartDirective,
        CheckallDirective,
        VectormapDirective,
        NowDirective,
        ScrollableDirective,
        ScrollToBottomDirective,
        JqcloudDirective,
        RuoliUtenteSelectComponent,
        InfoUtenteComponent,
        InputNumberComponent,
        PreferitiComponent,
        AzioniPreferitiModal,
        AzioniMenuRicercaComponent,
        AzioneMenuModalComponent,
        FunzioniAzioneMenuSectionComponent,
        FunzioneAzioneMenuModalComponent,
        TipoAllegatoSelectComponent,
        AllegatoModalComponent,
        AllegatiSectionComponent,
        AllegatiTipoSectionComponent,
        CassaSelectComponent,
        StazioniComponent,
        StazioneComponent,
        AzureLoginComponent,
        AssociaStazioneModalComponent,
        CasseComponent,
        CassaComponent,
        TipoCassaSelectComponent,
        TipoPistaSelectComponent,
        PisteComponent,
        PistaComponent,
        TipoAssistenzaSelectComponent,
        StazioneSelectComponent,
        TipoPagamentoSelectComponent,
        PistaSelectComponent,
        ClasseVeicoloSelectComponent,
        ModalitaAssistenzaCasseSelectComponent,
        InGestioneSelectComponent,
        StazioneEntrataSelectComponent,
        TrattaSelectComponent,
        WidgetCassaComponent,
        TipoAssistenzaBadgeComponent,
        StatoAssistenzaBadgeComponent,
        StatoAssistenzaSelectComponent,
        TipoCodiceSelectComponent,
        TipoAssistenzaReportComponent,
        TotaliStazioneBadgeComponent,
        BottoniStatoAssistenzaComponent,
        TipoScontrinoSelectComponent,
        NewTabButtonComponent,
        OperatoreSelectComponent,
        BottoniStampaAssistenzaComponent,
        ConBarcodeSelectComponent,
        ConRimborsoAmministrativoSelectComponent
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        RouterModule,
        AccordionModule,
        AlertModule,
        ButtonsModule,
        CarouselModule,
        CollapseModule,
        BsDatepickerModule,
        BsDropdownModule,
        ModalModule,
        PaginationModule,
        ProgressbarModule,
        RatingModule,
        TabsModule,
        TimepickerModule,
        TooltipModule,
        PopoverModule,
        TypeaheadModule,
        ToastrModule,
        FlotDirective,
        SparklineDirective,
        EasypiechartDirective,
        CheckallDirective,
        VectormapDirective,
        NowDirective,
        ScrollableDirective,
        ScrollToBottomDirective,
        JqcloudDirective,
        TooltipModule,
        S1Module,
        RuoliUtenteSelectComponent,
        InfoUtenteComponent,
        InputNumberComponent,
        TranslatePipe,
        PreferitiComponent,
        AzioniPreferitiModal,
        AzioniMenuRicercaComponent,
        AzioneMenuModalComponent,
        FunzioniAzioneMenuSectionComponent,
        FunzioneAzioneMenuModalComponent,
        TipoAllegatoSelectComponent,
        AllegatoModalComponent,
        AllegatiSectionComponent,
        AllegatiTipoSectionComponent,
        CassaSelectComponent,
        StazioniComponent,
        StazioneComponent,
        AzureLoginComponent,
        CasseComponent, 
        CassaComponent,
        TipoCassaSelectComponent,
        PisteComponent,
        TipoPistaSelectComponent,
        TipoAssistenzaSelectComponent,
        StazioneSelectComponent,
        TipoPagamentoSelectComponent,
        PistaSelectComponent,
        ClasseVeicoloSelectComponent,
        ModalitaAssistenzaCasseSelectComponent,
        InGestioneSelectComponent,
        StazioneEntrataSelectComponent,
        TrattaSelectComponent,
        WidgetCassaComponent,
        TipoAssistenzaBadgeComponent,
        StatoAssistenzaBadgeComponent,
        StatoAssistenzaSelectComponent,
        TipoCodiceSelectComponent,
        TipoAssistenzaReportComponent,
        TotaliStazioneBadgeComponent,
        BottoniStatoAssistenzaComponent,
        TipoScontrinoSelectComponent,
        NewTabButtonComponent,
        OperatoreSelectComponent,
        BottoniStampaAssistenzaComponent,
        ConBarcodeSelectComponent,
        ConRimborsoAmministrativoSelectComponent
    ]
})

// https://github.com/ocombe/ng2-translate/issues/209
export class SharedModule {
    static forRoot(): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule
        };
    }
}
